import React, { useEffect, useMemo, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useDispatch, useSelector } from "react-redux";
import { RECOGNISED_SECTION_MODAL_DETAILS, SET_SHOW_RECOGNISED_SECTION } from "../../redux/actions/types";
import { recognitionSection } from "../../common/constants";


export const SLIDE_SPEED = 2500
const NewRecognisedSection = ({ setSwiperInstance, swiperInstance }) => {
  const dispatch = useDispatch();

  const [ glowSlide, setGlowSlide ] = useState(null)

  const glowTimeoutRef = useRef(null)
  const initialGlowTimeoutRef = useRef(null)
  const width  = window.innerWidth;
  const type = useSelector(state => state?.onBoarding?.type)

  useEffect(() => {
    initialGlowTimeoutRef.current = setTimeout(() => {
        setGlowSlide(0)
        setTimeout(() => {
            setGlowSlide(null)
        }, 1100)
    }, SLIDE_SPEED)
  
    return () => {
        if (initialGlowTimeoutRef.current) clearTimeout(initialGlowTimeoutRef.current)
    }
}, [])


  useEffect(() => {
    return () => {
      dispatch({ type: SET_SHOW_RECOGNISED_SECTION, payload: false });
    };
  }, [dispatch]);


  const handleSlideChange = (swiper) => {
      
    if (initialGlowTimeoutRef.current) {
        clearTimeout(initialGlowTimeoutRef.current)
        initialGlowTimeoutRef.current = null
    }
  
    if (glowTimeoutRef.current) {
        clearTimeout(glowTimeoutRef.current)
    }
  
    glowTimeoutRef.current = setTimeout(() => {
        setGlowSlide(swiper.realIndex)
    
        setTimeout(() => {
            setGlowSlide(null)
        }, 1100)
    }, SLIDE_SPEED)
}


  const handleModal = (item, originalIndex) => {
    if(swiperInstance){
        swiperInstance?.autoplay?.stop()
    }
    console.log('item', item)
    dispatch({
      type: RECOGNISED_SECTION_MODAL_DETAILS,
      payload: { item, originalIndex },
    });
    dispatch({ type: SET_SHOW_RECOGNISED_SECTION, payload: true });
  };

  

  const chunks = useMemo(() => {
    function chunkArray(array, size = 8) {
        const result = []
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size))
        }
        return result
    }

    return chunkArray(recognitionSection, 8)
}, [])

  return (
    <div className="w-[calc(100%+32px)] -ml-4 relative">
            <div className="flex items-center justify-center">
                <img src="https://assets.learntube.ai/files/recognised_section/Group%2020761.png?updatedAt=1745660796666" width={40} height={40} alt="" />
            </div>
            {type === "job" ? <div className="mt-2 px-3 text-white">
                <h2 className="text-2xl text-center font-medium"> Learners Who Took This Path And Got Hired </h2>
            </div> : <div className="mt-2 px-3 text-white">
                <h2 className="text-2xl text-center font-medium">Your Certificate is Recognised by <span className="font-bold">1100+Top Companies</span></h2>
            </div>}
            <div className="pt-6 px-3">
                <p className="text-xs flex items-center justify-center text-[#D3D8DE] font-light italic mb-2"><img src="https://assets.learntube.ai/files/recognised_section/Frame%20427321172.png?updatedAt=1745670254977"width={24} height={11} className="image-inline transform scale-y-[-1]" alt="" />Tap  for Success Stories</p>
                <Swiper
                    onSwiper={setSwiperInstance}
                    spaceBetween={12}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false
                    }}
                    speed={2000}
                    modules={[Autoplay ]}
                    className="mySwiper"
                    onSlideChange={handleSlideChange}
                >
                    {chunks?.map((item, index) => {
                        return (<SwiperSlide key={index} className="w-full grid grid-cols-4 grid-rows-2 gap-2">
                            <div className="grid grid-cols-4 grid-rows-2 gap-4">
                                {item?.map((card, cardIndex) => {

                                    const originalIndex = index * 8 + cardIndex;

                                    return (<div key={cardIndex} className="p-[0.5px] rounded-lg sm:rounded-xl cursor-pointer" onClick={() => handleModal(card, originalIndex)}
                                        style={{
                                            backgroundImage: 'conic-gradient(from 180deg, rgba(253, 253, 253, 0) 36%, rgba(255, 255, 255, 0.6) 40%, rgba(251, 251, 251, 0.576) 61%, rgba(253, 253, 253, 0.042) 65%)'
                                        }}
                                    >
                                        <div 
                                            className={`py-4 px-2 rounded-lg sm:rounded-xl bg-[#102941] ${glowSlide === index ? 'btn--glow' : ''}`}
                                            style={{
                                                backgroundImage: 'radial-gradient(circle, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.5) 25%, rgba(255, 255, 255, 0.43) 40%, rgba(255, 255, 255, 0.36) 49%, rgba(255, 255, 255, 0.3) 59%, rgba(255, 255, 255, 0.18) 88%, rgba(255, 255, 255, 0.13) 100%)',
                                            }}
                                        >
                                            <img 
                                                src={card?.companyImage} 
                                                height={40} 
                                                width={60} 
                                                className={`mx-auto ${width <= 320 ? 'h-7' : width <= 360 ? 'h-8' : 'h-10'} w-auto`} 
                                                alt=""
                                                style={{
                                                    filter: 'drop-shadow(0px 0.5px 0px #424447) drop-shadow(0px 1px 0px #424447) drop-shadow(0px 1.5px 0px #424447) drop-shadow(0px 2px 0px #424447)',
                                                }}
                                            />
                                            <p className="text-xs font-semibold text-center truncate mt-2">{card?.finalOrgTitle}</p>
                                            <div className="mt-1.5">
                                                <img src={card?.profileImage} width={24} height={24} className="rounded-full border border-white mx-auto" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                )})}
                            </div>
                        </SwiperSlide>
                    )})}
                </Swiper>       
            </div>
    </div>
  );
};


export default NewRecognisedSection;